module.exports = __webpack_public_path__ + "static/media/code-slash-outline.b991a4cb.svg";